<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Dokumente</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">Mit Trashed</option>
          <option value="only">Nur Trashed</option>
        </select>
      </search-filter>
      <inertia-link class="btn-green" :href="route('documents.create')">
        <span>Erschaffen</span>
        <span class="hidden md:inline">Dokument</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Typ</th>
          <th class="px-6 pt-6 pb-4">Texte</th>
        </tr>
        <tr v-for="document in documents.data" :key="document.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-kreditgenie-text-green" :href="route('documents.edit', document.id)">
              {{ docTypes().find(dt => dt.key === document.type).value }}
              <icon v-if="document.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('documents.edit', document.id)" tabindex="-1">
              {{ document.text | stripHTML }}
            </inertia-link>
          </td>
          <td class="border-t" />
        </tr>
        <tr v-if="documents.data.length === 0">
          <td class="border-t px-6 py-4" colspan="9">Keine Dokuments gefunden.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="documents.links" />
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import Icon from '../../Shared/Icon'
import {docTypes} from './docTypes'

export default {
  metaInfo: { title: 'Dokumente' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    documents: Object,
  },

  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },

  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('documents'), pickBy(this.form), { preserveState: true })
      }, 100),
    },
  },

  methods: {
    docTypes() {
      return docTypes
    },
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
  filters: {
    stripHTML: function(string) {
      return string ? string.replace(/<\/?[^>]+>|&nbsp;/ig, ' ') : string
    },
  },
}
</script>
